import axios from 'axios'
import HTTP from './http'

export default {
    getList: payload => axios.get(HTTP.POLICY_COLLECTION_LIST, { params: payload }),
    addCollection: payload => axios.post(HTTP.POLICY_COLLECTION_ADD, payload),
    deleteCollection: payload => axios.delete(HTTP.POLICY_COLLECTION_DELETE, { params: payload })
}
